module.exports = __webpack_public_path__ + "static/media/Play_Store.d0b2978a.png";